import { useQuery } from "react-query";

import axios from "axios";

import {
  BinSizeQueryParams,
  BinSizeQueryResponse,
  UseBinSizeQueryResult
} from "../types";

const dataRoot = process.env.REACT_APP_DATA_RS_ROOT;

// EVA-6412 SR-003 — fixes P3. The axios GET call, URL, and query params are
// UNCHANGED from the pre-refactor inline call inside updateField (BP-003);
// only the calling mechanism becomes a declarative useQuery.
export const useBinSizeQuery = (params: BinSizeQueryParams): UseBinSizeQueryResult => {
  const {
    filterId,
    property,
    normalizeField,
    per,
    pdenSource,
    entityKind,
    useDynamicBins,
    forecastTrumpingSettings,
    performanceDateRange,
    enabled
  } = params;

  const { data, isFetching, error, refetch } = useQuery<BinSizeQueryResponse>(
    [
      "binSize",
      filterId,
      property,
      normalizeField,
      per,
      pdenSource,
      entityKind,
      useDynamicBins,
      forecastTrumpingSettings,
      performanceDateRange
    ],
    async () => {
      const encodedProperty = btoa(encodeURIComponent(property));
      const url = `${dataRoot}/api/v1/data/bin-size/${filterId}/${encodedProperty}`;
      const queryParams = new URLSearchParams({
        normalizeField: normalizeField ?? "''",
        per: (per ?? 0).toString(),
        pdenSource: pdenSource.toString(),
        entityKind,
        useDynamicBins: useDynamicBins.toString()
      });

      if (forecastTrumpingSettings) {
        const {
          forecastSources,
          userForecastFolderId,
          syncJob,
          syncJobRescat,
          userForecastRescat
        } = forecastTrumpingSettings;
        if (forecastSources?.length > 0) {
          queryParams.set("forecastSources", forecastSources.join(","));
        }
        if (userForecastFolderId) {
          queryParams.set("userForecastFolderId", userForecastFolderId);
        }
        if (syncJob) {
          queryParams.set("syncJob", syncJob);
        }
        if (syncJobRescat) {
          queryParams.set("syncJobRescat", syncJobRescat);
        }
        if (userForecastRescat) {
          queryParams.set("userForecastRescat", userForecastRescat);
        }
      }
      if (performanceDateRange) {
        queryParams.set("startDate", performanceDateRange.startDate);
        queryParams.set("endDate", performanceDateRange.endDate);
      }

      const fullUrl = `${url}?${queryParams.toString()}`;
      const response = await axios.get(fullUrl);
      if (response.status === 200) {
        return response.data;
      }
      return null;
    },
    {
      enabled,
      staleTime: 0,
      refetchOnWindowFocus: false,
      keepPreviousData: true
    }
  );

  return { data, isFetching, error, refetch };
};
